import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			color: ({ usePaperColors }) => theme.palette.getTextColors(usePaperColors).secondary,
			display: 'block',
			'& $label': {
				paddingTop: theme.spacing(0.3),
				...theme.typography.caption,
			},
		},
		checkbox: {
			color: theme.palette.primary.main,
		},
		label: {},
		error: {
			left: theme.spacing(3.4),
			marginTop: theme.spacing(-0.9),
		},
	}),
	{ name: 'Form-Checkbox123' },
)

export default useStyles
